<template>
    <div v-if="additionals">
        <List
            v-if="additionals.plantaoId"
            :fields="fields"
            :plantao-faixa-etaria-id="additionals.plantaoFaixaEtariaId"
            :setor-tipo-id="enums.setorTipo.CONSULTORIO"
            @status-changed="handleStatusChanged"
        >
            <template v-slot:tempo-espera="{ item }">
                <span
                    :title="`Reavaliação solicitada por: ${item.atendimento.reavaliacaoProfissional}`"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon
                        v-if="item.atendimento.reavaliacao"
                        class="ml-3"
                        icon="undo-alt"
                    />
                </span>

                <span
                    v-if="item.hasAtendimentoObservacao"
                    title="Paciente encaminhado do setor de observação"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon
                        class="ml-3"
                        icon="exclamation-triangle"
                    />
                </span>
            </template>

            <template v-slot:custom-actions="{ item }">
                <rkm-button
                    @click="answer(item)"
                    color="primary"
                    small
                    title="Atender"
                    authorize="store-pronto-atendimento-atendimento-medico"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>

                <rkm-button
                    color="info"
                    small
                    title="Imprimir"
                    @click="getImpressoes(item.atendimento.id, enums.setorTipo.CONSULTORIO)
                        .then(impressoes => $refs.ModalImpressao.open(impressoes, item.atendimento.id))"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEvasao.open(item.id)"
                    color="danger"
                    small
                    title="Evadir"
                >
                    <rkm-icon icon="running" />
                </rkm-button>
            </template>
        </List>

        <rkm-alert color="warning" v-else>
            Não existe nenhum plantão cadastrado para este usuário.
        </rkm-alert>

        <ModalEvasao ref="ModalEvasao" />
        <ModalImpressao ref="ModalImpressao" />
    </div>
</template>

<script>
import { prontoAtendimentoFila } from '@/mixins'
import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'

// Mixins.
import { error, repository } from '@/mixins'

export default {
    components: { ModalImpressao },
    created() {
        this.repositories.medico = this.getConectaSusRepository('prontoAtendimento.atendimentoMedico')
    },
    data: () => ({
        additionals: null,
        createRouteName: 'pronto-atendimento-atendimento-medico-create',
        repositories: {
            medico: null,
        },
    }),
    methods: {
        load() {
            this.repositories.medico.index()
                .then(response => {
                    this.additionals = response.data.additionals
                    this.model.currentPlantaoId = this.additionals.plantaoId
                })
                .catch(this.handleError)
        },
    },
    mixins: [ error, prontoAtendimentoFila, repository ],
    mounted() {
        this.load()
    },
}
</script>